export interface UserListeningPackagesResponse {
  userListeningPackages: UserListeningPackage[];
  offerablePackages: ListeningPackage[];
}

export interface UserListeningPackage {
  usedDuration: number;
  status: string;
  listeningPackage: ListeningPackage;
  msisdn: string;
  remainingDuration: number;
  nextRenewalDate: Date;
  usedCredit: number;
  remainingCredit: number;
  cancelReqSent: boolean;
  billStatus: boolean;
}

export interface ListeningPackage {
  smsKeyword: string;
  forOffline: boolean;
  type: number;
  listenLimit: number;
  highSoundQuality: boolean;
  price: number;
  priceUnit: string;
  description: string;
  name: string;
  relatedSdpOfferId: string;
  offerId: string;
  radioPackage: boolean;
  welcomePackage: boolean;
  priceDescription?: string;
  billStatus: boolean;
  premium?:boolean;
  paid?:boolean;
  student?:boolean;
  nameInTR?:string;
  period?:string;
  family?:FamilyPlanTypes;
  packageSegment?:ListeningPackageSegment;
  sardisOfferId?:string;
  manageSubscription?: boolean;
  changePaymentMethod?: boolean;
  basePrice: number;
  /** Deneme doneminin birimi: "MONTHLY" / "YEARLY" */
  trialPeriod?: string;
  /** Paketin kendi deneme donemi sayisi; promokodsuz bedava ay sayisi budur. */
  trialPeriodCount?: number;
}

export interface ListeningPackageAvailability {
  available: boolean;
  explanation: string;
}

export interface PackageThumbnail {
  id: string;
  name: string;
  description: string;
  smsKeyword: string;
  type?: number;
  price?: any;
  priceUnit?: string;
  userRight?: UserRight;
  priceDescription?: string;
  cancelReqSent?: boolean;
  relatedSDP?: string;
  welcomePackage?:boolean;
  radioPackage?:boolean;
  toggle?:boolean;
  period?:string;
  status?:string;
  descHeader?:string;
  descContent?:string;
  icon?:string;
  isPremium?:boolean;
  isPaid?:boolean;
  isStudent?:boolean;
  nextRenewalDate?: Date;
  cancelDescription?: string;
  nameInTR?:string;
  billStatus?: boolean;
  studentPlanDesc?: string;
  studentPlanClass?: string;
  family?:FamilyPlanTypes;
  packageSegment?:ListeningPackageSegment;
  sardisOfferId?: string;
  manageSubscription?: boolean;
  changePaymentMethod?: boolean;
  basePrice?: any;
  /** Deneme doneminin birimi: "MONTHLY" / "YEARLY" */
  trialPeriod?: string;
  /** Paketin kendi deneme donemi sayisi; promokodsuz bedava ay sayisi budur. */
  trialPeriodCount?: number;
}


export enum ListeningPackageSegment {
  STANDART = "Standart",
  STANDARD = "Standard",
  BIREYSEL = "Bireysel",
  INDIVIDUAL = "Individual",
  OGRENCI = "Öğrenci",
  STUDENT = "Student",
  DUO = "Duo",
  AILE = "Aile",
  FAMILY = "Family",
  SESLI = "Premium",
  BIREYSEL_SESLI = "Premium+",
  BUNDLE_SESLI = "Bundle Sesli Kitap",
  BUNDLE_AUDIOBOOK = "Bundle Audiobook",
}



export enum FamilyPlanTypes {
  NON_FAMILY = "NON_FAMILY",
	FAMILY = "FAMILY",
	DUO = "DUO"
}

export interface PriceDetails {
  firstThreePrice: string;
  laterPrice: string;
  totalPrice: string;
  pricePeriod: string;
  priceUnit: string;
  time: string;
  firstPrice: string;
  descriptionTr: string;
  descriptionEn: string;
  firstXMonth: string;
  firstXPrice: string;
  firstXFree: string;
  basePrice: string;
}

export interface UserRight {
  currentValue: number;
  endDate: Date;
  offerName: string;
  packageId: number;
  remainingValue: number;
  startDate: Date;
  stillHasRights: boolean;
  totalValue: number;
  description: string;
  price: string;
  priceUnit: string;
  period: string;
  nameInTR?:string;
}

export interface Date {
  minutes?: number;
  seconds?: number;
  hours?: number;
  month?: number;
  year?: number;
  day?: number;
  milliseconds?: number;
}

export enum ListeningPackageType {
  SDP,
  DAILY,
  GOOGLEPLAY,
  APPLESTORE,
  PAYCELLPAYMENT,
  CREDITCARD,
  MOBILODEME
}

export interface Payment {
  userId: number;
  userListeningPackages: UserListeningPackage[];
  paymentMethodId?: string;
  cardId?:string;
  masterpassCardName?: string;
  masterpassCardUid?: string;
}


export interface StudentPlan{
  expireDate: Date,
  studentPlanStatus: StudentPlanStatus
}

export enum StudentPlanStatus{
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  NOT_APPLIED = "NOT_APPLIED",
  BLOCKED = "BLOCKED",
  LIMIT_EXCEEDED = "LIMIT_EXCEEDED",
  QUOTA_EXCEEDED = "QUOTA_EXCEEDED",
  DOC_UPLOAD = "DOC_UPLOAD"
}

export enum CancelSubscriptionType {
  IMMEDIATE = "IMMEDIATE",
  COMMITMENT = "COMMITMENT"
}

export interface HashRequestResponse{
  transactionId: string,
  transactionDateTime: string,
  hashData: string
}

export interface PromocodeResponse {
  valid: boolean;
  discountRate: string;
  discountedPrice: string;
  discountedRenewalCount: string;
  errorCode: string;
  errorMessage: string;
  redirectOfferId: string;
  redirectPackageName: string;
  discountedPrices?: DiscountedPriceItem[];
  trialCount?: number;
  trialDiscountedPrice?: number;
  postTrialOriginalPrice?: number;
  postTrialDiscountedPrice?: number;
  promocodeAppliedCount?: number;
  computedDiscountRate?: number;
  hasTrial?: boolean;
  hasPostTrial?: boolean;
  calculateSummary?: PromocodeCalculateSummary;
}

/**
 * discountedPrices dizisinin, paket kartinda gosterilecek hale indirgenmis ozeti.
 * Her promokod isteginde bastan uretilir, kod iptal edilince temizlenir.
 */
export interface PromocodeCalculateSummary {
  /** discountedPrices dizisinin eleman sayisi */
  totalCount: number;
  /** trial === true olan eleman sayisi */
  trialCount: number;
  /** trial === true ve promocodeApplied === true olan eleman sayisi */
  promocodeAppliedTrialCount: number;
  /**
   * Trial bayragi fiyat tabanli sayimdan fazla bedava ay gosteriyor ve promokod
   * trial aylarin tamamini kapsamiyor. Bu durumda bedava ay sayimi fiyat
   * alanlarindan degil trial bayragindan alinir.
   */
  trialOverridesFreeCount: boolean;
  /**
   * Bedava ay sayisi. Normalde bastan itibaren odenen tutari 0 olan ardisik eleman
   * sayisi; trialOverridesFreeCount true ise trialCount degeri ile ezilir.
   */
  freeCount: number;
  /** discountedPrices[0].trial */
  startsWithTrial: boolean;
  /** discountedPrices[0].promocodeApplied - kampanya penceresi bedava ayi kapsiyor mu */
  promocodeAppliedOnFirst: boolean;
  /** tum elemanlarin price degeri 0 */
  allFree: boolean;
  /** ilk ucretli ayin price degeri */
  standardPrice?: number;
  /** ilk ucretli ayin discountAmount degeri */
  discountAmount?: number;
  /** ilk ucretli ayin discountedPrice degeri */
  discountedPrice?: number;
  /** yesil bilgi kutusunda yazilacak ay sayisi: indirim uygulanan eleman sayisi */
  discountMonthCount: number;
}

export interface PromocodeCalculateRequest {
  offerId: string;
  promoCode: string;
}

export interface DiscountedPriceItem {
  renewCount: number;
  price: number;
  discountedPrice: number;
  /** calculate cevabinda her zaman gelmez; yoksa price - discountedPrice kullanilir. */
  discountAmount?: number;
  trial: boolean;
  promocodeApplied: boolean;
  cardCampaignApplied: boolean;
}

export interface PromocodeCalculateCampaignDetail {
  id?: number;
  name?: string;
  type?: string;
  startDate?: string;
  endDate?: string;
  maxRenewCount?: number;
  discountType?: number;
  discount?: number;
  promoCode?: string;
}

export interface PromocodeCalculateOfferDetail {
  offerId?: number;
  offerName?: string;
  period?: string;
  priceUnit?: string;
}

export interface PromocodeCalculateResponse {
  campaignDetail?: PromocodeCalculateCampaignDetail;
  offerDetail?: PromocodeCalculateOfferDetail;
  discountedPrices?: DiscountedPriceItem[];
}

export interface CheckChurnResponse {
  price: string;
  discountRate: string;
  discountedPrice: string;
  discountedRenewalCount: string;
}

export interface ApplyChurnSuccessResponse {
  day?: number;
  month?: number;
  year?: number;
  discountedMonth: string;
  discountedPrice: string;
}



// WEBPACK FOOTER //
// src/app/common/services/package/package.model.ts